import Vue from 'vue';

// 图片
Vue.filter('toImgPath', val => process.env.SYS_URL + val);

// 我的订单
Vue.filter('enTypeStr', (type) => {
  if (type === '1') {
    return '机会公海';
  } else if (type === '2') {
    return '意向客户';
  }
  return '签约客户';
});

// 时间颜色
Vue.filter('timeOutColor', (strtTime, endTime) => {
  const cha = Math.floor((endTime - strtTime) / 86400);
  if (cha >= 15) {
    return 'text-danger';
  }
  return 'text-success';
});



// WEBPACK FOOTER //
// ./src/util/filter.js